import React from 'react';

import BdsCircleIndicatorPictogram from '../../../../../../../shared/components/v3/BdsCircleIndicator/BdsCircleIndicatorPictogram/BdsCircleIndicatorPictogram';
import BdsRadioButton from '../../../../../../../shared/components/v3/BdsRadioButton/BdsRadioButton';
import BdsCardContainer from '../../../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import { IButtonImageV3 } from '../../../../../../../shared/interfaces/button';

import './SelectLoadMethodCard.scss';

interface ILoadMethodCard {
  pictogram: {
    component?: IButtonImageV3;
    url?: string;
  };
  selected: boolean;
  title: string;
  description: string;
  disclaimer: string;
  onClick: () => void;
}

const LoadMethodCard = ({ pictogram, selected, title, description, disclaimer, onClick }: ILoadMethodCard) => {
  return (
    <BdsCardContainer
      onClick={onClick}
      className={'load-method-card-container'}
      paddingSize="padding-l"
      borderRadiusSize="radius-l"
    >
      <div className="load-method-card-top-content">
        <BdsCircleIndicatorPictogram
          className={'load-method-card-circle-indicator-pictogram'}
          circleIndicatorSize="s"
          pictogram={pictogram}
        />
        <BdsRadioButton name={title} onChange={onClick} selected={selected} value={'value'} variant="primary" />
      </div>
      <div className="load-method-card-information-content">
        <div className="load-method-card-information-content-title">{title}</div>
        <div className="load-method-card-information-content-description">{description}</div>
        <div className="load-method-card-information-content-disclaimer">{disclaimer}</div>
      </div>
    </BdsCardContainer>
  );
};

export default LoadMethodCard;
